import master from '../../assets/diplome/master.pdf'

export const FormationData = [
  {
    "id": 1,
    "diplome": "Master Geographie Amenagement Environnement Developpement",
    "ville": "Angers",
    "intitule": "",
    "dateAdmission": "2021",
    "specialisation": "Ecologie et eco-ingenierie des zones humides",
    "projets": "",
    "downloadLink": master,
    "diplomeName": "Master GAED et BEE",
    "size": ""
  },
  {
    "id": 2,
    "diplome": "Maitrise Biologie Ecologie et Evolution",
    "ville": "Poitiers",
    "intitule": "",
    "dateAdmission": "2020",
    "specialisation": "Biogeographie et genomique",
    "projets": "",
    "downloadLink": "",
    "diplomeName": "Maitrise BEE",
    "size": ""
  },
  {
    "id": 3,
    "diplome": "Maitrise Geographie Amenagement Environnement Developpement",
    "ville": "Poitiers",
    "intitule": "",
    "dateAdmission": "2019",
    "specialisation": "Mobilites actives & resiliance des territoires",
    "projets": "",
    "downloadLink": "",
    "diplomeName": "Maitrise GAED",
    "size": ""
  },
  {
    "id": 4,
    "diplome": "Licence Biologie des Organismes, des Populations et Environnement",
    "ville": "Toulouse",
    "intitule": "",
    "dateAdmission": "2018",
    "specialisation": "Ornithologie, phylogenie, comportement animale, biostatistiques",
    "projets": "",
    "downloadLink": "",
    "diplomeName": "Licence",
    "size": ""
  }
]
